import React from 'react'

import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'

import './styles/styles.scss'

function App ({ children }) {
  return (
    <>
      <Header/>
      <main className="wrapper">
        {children}
      </main>
      <Footer/>
    </>
  )
}

export default App
